/**
 * @description 只处理v数值读写、更新
 * @class VObject
 */
abstract class VObject {
  public vObject: any;
  public msg: any;
  private vNames: { [key: string]: string };
  private conditionMap: any;
  private conditionResults: any;
  public constructor() {
    this.vObject = {};
    this.vNames = {};
    this.conditionMap = {};
    this.conditionResults = {};
  }

  // 在v数值对象里添加新的key
  public updateValue(key: string, setValue: number) {
    let value = Number(setValue) || 0; // 缓存value
    if (typeof this.vObject[key] !== 'number') {
      Object.defineProperty(this.vObject, key, {
        get() {
          return value;
        },
        set: (val) => {
          if (value !== val) {
            value = Number(val);
            this.onValueUpdate(key, val);
            if (this.conditionMap[key]) {
              this.conditionMap[key].forEach((condition: string) => {
                const result = this.excuteCondition(condition);
                if (result !== this.conditionResults[condition]) {
                  this.conditionResults[condition] = result;
                  this.onConditionUpdate(condition, result);
                }
              });
            }
          }
        },
        configurable: true,
        enumerable: true,
      });
      this.onValueUpdate(key, setValue);
    }
    this.vObject[key] = value;
  }

  // 获取数值的名称
  public getValueName(key: string) {
    return this.vNames[key];
  }

  // 批量更新v数值
  public updateValues(data: {
    expression?: string;
    numbers?: Array<{ key: string; value: number; description?: string; name?: string; }>;
  }) {
    const { expression, numbers } = data;
    if (numbers?.length) {
      numbers.forEach((item) => {
        const { key, value, description, name } = item;
        this.vNames[key] = description || name;
        this.updateValue(key, value);
      });
      // 避免冲突 有numbers就不执行表达式了
      return;
    }
    if (expression) {
      const [excuteExpression, condition] = expression.split('#');
      if (condition && !this.excuteCondition(condition)) {
        console.warn('v数值条件不满足');
        return;
      }
      const expressions = excuteExpression.split(',');
      expressions.forEach((exp) => {
        this.setVObject(exp);
      });
    }
  }

  // 通过表达式更新v数值
  public setVObject(expression: string) {
    this.excute(this.vObject, expression);
  }

  // 获取当前的v数值
  public getVObject() {
    // return JSON.parse(JSON.stringify(this.vObject)) // 返回副本
    return this.vObject;
  }

  public async getValue(props: string) {
    return this.vObject[props];
  }

  public listenCondition(condition: string) {
    // 判断condition里有哪些变量
    if (condition) {
      condition.match(/(\w+)/g).forEach((item) => {
        if (this.vObject[item] || this.vObject[item] === 0) {
          if (!this.conditionMap[item]) this.conditionMap[item] = [];
          this.conditionMap[item].push(condition);
        }
      });
      this.conditionResults[condition] = this.excuteCondition(condition);
      this.onConditionUpdate(condition, this.conditionResults[condition]);
    }
  }

  public excuteCondition(expression: string) {
    return this.excute(this.vObject, expression);
  }

  private excute(scope: object, expression: string) {
    let exp = expression;
    exp = exp.replace(/\s/g, '');
    exp = ` ${exp}`;
    const quickRegex = /([\s+\-*/%&|^!~:[(<>=?])([a-z_$][a-z_$0-9]*)/g;
    exp = exp.replace(quickRegex, (a, b, c) => `${b}scope.${c}`);
    // eslint-disable-next-line no-new-func
    const func = new Function('scope', `return ${exp}`);
    return func(scope);
  }

  protected abstract onValueUpdate(key: string, value: number): void;

  protected abstract onConditionUpdate(condition: string, result: boolean): void;
}

export default VObject;
